// src/composables/useSeo.js
import { onUnmounted } from 'vue';

export default function useSeo(metaData) {
  const head = document.head;
  const createdTags = [];

  // Gestion de la langue
  if (metaData.lang) {
    document.documentElement.setAttribute('lang', metaData.lang);
  }

  // Gestion du titre
  if (metaData.title) {
    document.title = metaData.title;
  }

  // Gestion des meta tags (remplace les existants au lieu de dupliquer)
  Object.entries(metaData.meta || {}).forEach(([name, content]) => {
    const isOg = name.startsWith('og:');
    const attr = isOg ? 'property' : 'name';

    // Chercher une balise existante pour la remplacer
    const existing = head.querySelector(`meta[${attr}="${name}"]`);
    if (existing) {
      existing.setAttribute('content', content);
    } else {
      const metaTag = document.createElement('meta');
      metaTag.setAttribute(attr, name);
      metaTag.setAttribute('content', content);
      head.appendChild(metaTag);
      createdTags.push(metaTag);
    }
  });

  // Ajout de la balise canonique
  if (metaData.canonical) {
    const existing = head.querySelector('link[rel="canonical"]');
    if (existing) {
      existing.setAttribute('href', metaData.canonical);
    } else {
      const canonicalLink = document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      canonicalLink.setAttribute('href', metaData.canonical);
      head.appendChild(canonicalLink);
      createdTags.push(canonicalLink);
    }
  }

  // Nettoyage des balises créées dynamiquement
  onUnmounted(() => {
    createdTags.forEach((tag) => {
      if (tag.parentNode) head.removeChild(tag);
    });
    if (!metaData.title) document.title = 'Jacquart & Fils';
  });
}
